import { createAction } from 'redux-act';

export const updateSiteTracking = createAction<{
  builderDomain: string;
  galleryDomain: string;
}>();
